import { useRef } from "react"
import useComponentSize from "@rehooks/component-size"

import { ScrollArea } from "@/components/scroll-area"
import { BodyCaption } from "@/domains/design/components/body-caption"
import { cn } from "@/domains/library"
import { dollarsPrettified } from "@/domains/library/format"
import { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"
import { DisplayTokens } from "@/domains/tokens/components/display-tokens"

export const MinimalPoolList: React.FC<{
  maxHeight?: number
  pools: Array<MinimalPoolStore>
  onPoolSelect: (pool: MinimalPoolStore) => void
  onClose?: () => void
}> = ({ pools, onPoolSelect, onClose, maxHeight = 280 }) => {
  const ref = useRef<HTMLDivElement>(null)
  const refHeight = useComponentSize(ref)

  const poolListHeight = Math.max(Math.min(maxHeight, refHeight.height), maxHeight)

  const handlePoolSelect = (pool: MinimalPoolStore) => {
    onPoolSelect(pool)
    onClose?.()
  }

  return (
    <div className="h-full flex-grow" ref={ref}>
      <BodyCaption className="mb-1 ml-1 text-t200">Pools</BodyCaption>
      <ScrollArea className={cn("-mx-2 rounded-md border-primary pr-3")} style={{ height: `${poolListHeight}px` }}>
        <div className="flex flex-col items-center space-y-1">
          {pools.map((pool: MinimalPoolStore) => {
            return (
              <div
                key={pool.address.toString()}
                className="flex w-full cursor-pointer items-center justify-between gap-2 rounded-xl bg-transparent px-3 py-4 text-sm transition-colors hover:bg-p400-light/50"
                onClick={() => handlePoolSelect(pool)}
              >
                <div className={"flex w-full items-center justify-start gap-2"}>
                  <DisplayTokens tokens={[pool.token0, pool.token1]} tokenSize={32} />
                  <div className="flex flex-col items-start">
                    <div className="text-xs text-t100">{pool.displayName}</div>
                    <div className="text-xs text-t200">{pool.displayType}</div>
                  </div>
                </div>
                <div className="text-t200">{dollarsPrettified(pool.tvlUsd)}</div>
              </div>
            )
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
